import {apiInstance} from '../../../api/api_Instance';
import {queryOptions} from '@tanstack/react-query';

export const brandFilterApi = {
  getBrandList: ({carTypeId}) => {
    return queryOptions({
      queryKey: ['brand', 'list', carTypeId],
      queryFn: (meta) =>
        apiInstance.get(`/carbrands/?type=${carTypeId}`, {
          signal: meta.signal,
        }),
      enabled: !!carTypeId,
      select: (data) => {
        return data.data.map((brandData) => ({
          id: brandData.id,
          value: brandData.id,
          text: brandData.brand,
        }));
      },
    });
  },
  getModelsList: ({carTypeId, brandId}) => {
    return queryOptions({
      queryKey: ['model', brandId],
      queryFn: (meta) =>
        apiInstance.get(`/carmodels/?brand_id=${brandId}&model_type_id=${carTypeId}`, {
          signal: meta.signal,
        }),
      enabled: !!brandId,
      select: (data) => {
        return data.data.map((modelData) => ({
          id: modelData.id,
          value: modelData.id,
          text: modelData.name,
        }));
      },
    });
  },
  getVolume: ({car_model_id}) => {
    return queryOptions({
      queryKey: ['volume', car_model_id],
      queryFn: (meta) =>
        apiInstance.get(`/engines/names?car_model_id=${car_model_id}`, {
          signal: meta.signal,
        }),
      enabled: !!car_model_id,
      select: (data) => {
        return data.data.map((volumeData) => ({
          id: volumeData.name,
          value: volumeData.name,
          text: volumeData.name,
        }));
      },
    });
  },
  getProducts: ({car_model_id, name}) => {
    return queryOptions({
      queryKey: ['productsss'],
      queryFn: (meta) =>
        apiInstance.get(`/engines-with-products`, {
          params: {
            car_model_id: car_model_id,
            name: name,
          },
          signal: meta.signal,
        }),
      select: (data) => data.data,
      enabled: false,
    });
  },
};
